import {Action, Module} from 'vuex-module-decorators';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import {ChallengeProblemLocation} from '@/models/challenge.model';
import store from '@/store';
import {UserApi} from '@/api/user.api';
import {GoogleMapsMarker} from '@/utils/map';
import {EntityStateAdapter} from '@/store/base.store';

export const featureKey = 'challenge_problems';

// @ts-ignore
if (store.state.challenge_problems) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class ChallengeProblemsStoreModule extends EntityStateAdapter<ChallengeProblemLocation> {

  @Action({commit: 'insertMany', rawError: true})
  async fetchLocalesWithSameProblem(challengeId: number): Promise<ChallengeProblemLocation[]> {
    return await (new ChallengesApi())
      .getLocalesWithSameProblem(challengeId)
      .pipe(take(1))
      .toPromise()
  }


  @Action({commit: 'insertOne', rawError: true})
  async sendLocaleWithSameProblem(data: {
    challengeId: number,
    payload: ChallengeProblemLocation,
  }): Promise<ChallengeProblemLocation> {
    return await (new UserApi())
      .sendLocaleWithSameProblem(data.challengeId, data.payload)
      .pipe(take(1))
      .toPromise()
  }


  get problems(): ChallengeProblemLocation[] {
    return this._entities;
  }

  get markers(): GoogleMapsMarker[] {
    return this.problems.map((v) => {
      return {
        label: v.location,
        title: v.location,
        position: {
          lat: Number(v.latitude),
          lng: Number(v.longitude),
        },
      }
    });
  }
}
